import type { Theme, SxProps } from '@mui/material';

import { Box } from '@mui/material';

import { capitalizeWords } from 'src/utils/capitalize-words';

import { dataType } from 'src/constants';

const { ReportStatus } = dataType;

const statusChipStyles: Record<string, { bgcolor: string; border: string; text: string }> = {
  [ReportStatus.APPROVED]: { bgcolor: '#F0FDF4', border: '#86EFAC', text: '#166534' },
  [ReportStatus.SUBMITTED]: { bgcolor: '#F0F9FF', border: '#BAE6FD', text: '#0369A1' },
  [ReportStatus.CHANGES_REQUESTED]: { bgcolor: '#FFF7ED', border: '#FED7AA', text: '#C2410C' },
  [ReportStatus.DRAFT]: { bgcolor: '#F9FAFB', border: '#E5E7EB', text: '#6B7280' },
};

type ReportStatusChipProps = {
  status: string;
  sx?: SxProps<Theme>;
};

export function ReportStatusChip({ status, sx }: ReportStatusChipProps) {
  const cfg = statusChipStyles[status] ?? statusChipStyles[ReportStatus.SUBMITTED];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 0.75,
        py: '1px',
        borderRadius: '999px',
        border: '1px solid',
        borderColor: cfg.border,
        bgcolor: cfg.bgcolor,
        color: cfg.text,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {capitalizeWords(status)}
    </Box>
  );
}
